import React, { useState, useEffect } from "react";
import MainLogo from "../../../assets/images/logo_main_white.png";
import LoginImg from "../../../assets/images/login_img.svg";
import Cloud from "../../../assets/images/cloud.png";
import background from "../../../assets/images/background.png";

const LeftAuth = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1024); // < lg
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="h-[150px] lg:h-screen flex-1 relative flex flex-col items-center p-8 overflow-hidden
                 lg:bg-gradient-to-b lg:from-blue-400 lg:to-blue-500 "
      style={
        isSmallScreen
          ? {
              backgroundImage: `url(${background})`,
              backgroundSize: "cover",
              backgroundPosition: "bottom",
              backgroundRepeat: "no-repeat",
            }
          : {}
      }
    >
      <div className="text-center z-10">
        <div className="login_main_logo hidden lg:block ">
          <img src={MainLogo} alt="child" />
        </div>
      </div>
      <div className="login_img absolute 2xl:bottom-[-18px] xl:bottom-[-9px] lg:bottom-[-21px] right-0 hidden lg:block">
        <img src={LoginImg} alt="child" className="vert-move" />
      </div>
      <div className="cloud_img absolute 2xl:bottom-[-110px] xl:bottom-[-72px] lg:bottom-[-62px] w-full hidden lg:block">
        <img src={Cloud} alt="cloudIcon" className="w-full" />
      </div>
    </div>
  );
};

export default LeftAuth;
